<template>
  <v-dialog
    v-model="dialog"
    :persistent="options.persistent !== false"
    :max-width="options.width || 400"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar :color="options.color || 'primary'" density="compact" flat>
        <v-toolbar-title class="text-h5">{{ options.title || '입력' }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="prompt-dialog-text pt-4">
        <p v-if="options.message" class="prompt-dialog-message mb-4" v-html="options.message"></p>
        <v-form ref="form" @submit.prevent="confirm">
          <v-text-field
            ref="input"
            v-model="inputValue"
            :label="options.label || '값'"
            :rules="options.rules || []"
            required
            autofocus
            variant="underlined"
            @keydown.enter.prevent="confirm"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :color="options.buttonFalseColor || 'grey'" variant="text" @click="cancel">
          {{ options.buttonFalseText || '취소' }}
        </v-btn>
        <v-btn :color="options.buttonTrueColor || 'primary'" variant="text" @click="confirm">
          {{ options.buttonTrueText || '확인' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CustomPromptDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  data() {
    return {
      dialog: false,
      inputValue: '',
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(nextValue) {
        this.dialog = nextValue;
      },
    },
    dialog(nextValue) {
      this.$emit('update:modelValue', nextValue);
      if (nextValue) {
        this.focusInput();
      }
    },
    options: {
      immediate: true,
      deep: true,
      handler(nextOptions) {
        this.inputValue = nextOptions.initialValue || '';
      },
    },
  },
  methods: {
    focusInput() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.input?.focus?.();
        }, 100);
      });
    },
    async confirm() {
      const validation = await this.$refs.form?.validate();
      if (validation && validation.valid === false) {
        return;
      }
      this.$emit('confirm', this.inputValue);
      this.dialog = false;
    },
    cancel() {
      this.$emit('cancel');
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.prompt-dialog-text {
  color: rgba(0, 0, 0, 0.7);
}

.prompt-dialog-message {
  font-size: 0.93rem;
  line-height: 1.55;
  color: rgba(0, 0, 0, 0.64);
}

.prompt-dialog-message :deep(b),
.prompt-dialog-message :deep(strong) {
  color: rgba(0, 0, 0, 0.8);
  font-weight: 700;
}
</style>
